import { render, staticRenderFns } from "./EnduserMyParameters.vue?vue&type=template&id=4ef5d884&"
import script from "./EnduserMyParameters.vue?vue&type=script&lang=js&"
export * from "./EnduserMyParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports